export interface PageChangePlaybackControls {
  isPlaying: () => boolean;
  pause: () => void;
  seek: (time: number) => void;
  play: () => void;
}

/**
 * 翻到懒加载页时暂停播放，只允许最后一次翻页在资源就绪后恢复。
 */
export class PageChangePlaybackGate {
  private requestToken = 0;
  private waiting = false;
  private resumeRequested = false;

  /** 加载期间的播放请求延迟到当前目标页就绪后执行。 */
  deferPlay(): boolean {
    if (!this.waiting) return false;
    this.resumeRequested = true;
    return true;
  }

  /** 当前目标页就绪后必须播放；用于人工成功翻页的一次性页面播放。 */
  requestPlay(): void {
    this.resumeRequested = true;
  }

  /** 加载期间收到暂停请求后，不再自动恢复。 */
  notePause(): void {
    if (this.waiting) this.resumeRequested = false;
  }

  cancel(): void {
    this.requestToken += 1;
    this.waiting = false;
    this.resumeRequested = false;
  }

  async waitAndSync(
    time: number,
    waitUntilReady: () => Promise<void>,
    isCurrentTarget: () => boolean,
    controls: PageChangePlaybackControls
  ): Promise<boolean> {
    const token = ++this.requestToken;

    if (!this.waiting) this.resumeRequested = controls.isPlaying();
    this.waiting = true;

    controls.pause();
    controls.seek(time);

    // 步骤 1：等待懒加载；失败也继续走对齐/恢复，避免自动播放卡在暂停
    let loadError: unknown;
    try {
      await waitUntilReady();
    } catch (error) {
      loadError = error;
    }

    if (token !== this.requestToken) return false;
    if (!isCurrentTarget()) {
      this.waiting = false;
      this.resumeRequested = false;
      return false;
    }

    // 步骤 2：新加载的旁白 tween 已挂载，重新从目标页页首渲染一次。
    controls.seek(time);
    this.waiting = false;

    const shouldResume = this.resumeRequested;
    this.resumeRequested = false;
    if (shouldResume) controls.play();

    if (loadError) throw loadError;
    return true;
  }
}
